import React from 'react';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { useTemplatePicker } from '../../hooks/useTemplatePicker';
import type { Template } from '../../types';
import { TemplatePickerDesktop } from './TemplatePickerDesktop';
import { TemplatePickerMobile } from './TemplatePickerMobile';

export function TemplatePicker({
  templates,
  loading,
  onPick,
  filter = 'All',
  recommendedTag = null,
  onFilter,
}: {
  templates: Template[] | null;
  loading: boolean;
  filter?: string;
  recommendedTag?: string | null;
  onFilter?: (f: string) => void;
  onPick: (t: Template | null) => void;
}) {
  const isMobile = useIsMobile();
  const tpl = useTemplatePicker(templates, filter, recommendedTag);

  if (!isMobile) {
    return <TemplatePickerDesktop templates={templates} loading={loading} onPick={onPick} />;
  }

  return (
    <TemplatePickerMobile
      filters={tpl.filters}
      filter={filter}
      onFilter={onFilter ?? (() => undefined)}
      cards={tpl.cards}
      loading={loading}
      onPick={onPick}
    />
  );
}
